import moment from 'moment';
import { formatValueByMetric, replaceAllCharacter } from './CommonUtil';
export var logicalRuleSetting = [
    {
        value: "AND",
        character: "&&",
        label: "AND"
    },
    {
        value: "OR",
        character: "||",
        label: "OR"
    }
];
var titleComparision = "Comparision Operator";
export var comparisonOperators = [
    {
        name: "GT (>)",
        translateText: "gt",
        value: "GT",
        character: ">",
        characterHtml: "<strong title='" + titleComparision + "' class='text-info'>></strong>",
        type: "NUMBER"
    },
    {
        name: "GTE (≥)",
        translateText: "gte",
        value: "GTE",
        character: "≥",
        characterHtml: "<strong title='" + titleComparision + "' class='text-info'>≥</strong>",
        type: "NUMBER"
    },
    {
        name: "LT (<)",
        translateText: "lt",
        value: "LT",
        character: "<",
        characterHtml: "<strong title='" + titleComparision + "' class='text-info'><</strong>",
        type: "NUMBER"
    },
    {
        name: "LTE (≤)",
        translateText: "lte",
        value: "LTE",
        character: "≤",
        characterHtml: "<strong title='" + titleComparision + "' class='text-info'>≤</strong>",
        type: "NUMBER"
    },
    {
        name: "EQ (=)",
        translateText: "eq",
        value: "EQ",
        character: "=",
        characterHtml: "<strong title='" + titleComparision + "' class='text-info'>=</strong>",
        type: "NUMBER"
    },
    {
        name: "IS (exactly)",
        translateText: "is",
        value: "IS",
        character: "is in",
        characterHtml: "<strong title='" + titleComparision + "'>is</strong> in",
        type: "TEXT"
    },
    {
        name: "NOT IN (NOT belong to)",
        translateText: "not_in",
        value: "NIN",
        character: "is not in",
        characterHtml: "is <strong title='" + titleComparision + "'>not in</strong>",
        type: "TEXT"
    },
    {
        name: "IN (belong to)",
        translateText: "in",
        value: "IN",
        character: "is in",
        characterHtml: "is <strong title='" + titleComparision + "'>in</strong>",
        type: "TEXT"
    },
    {
        name: "LIKE (similar to)",
        translateText: "like",
        value: "LIKE",
        character: "contains",
        characterHtml: "<strong title='" + titleComparision + "'>contains</strong>",
        type: "TEXT"
    }
];
export var alertDataLevelOptions = [
    {
        value: "PLATFORM",
        label: "Platform"
    },
    {
        value: "PUBLISHER",
        label: "Publisher"
    },
    {
        value: "MEDIA",
        label: "Media"
    },
    {
        value: "PUBDESK_INVENTORY",
        label: "Pubdesk Inventory"
    }
];
export var actionCauseTypes = [
    {
        name: "Based on a single metric value of yesterday",
        nameTranslate: "",
        value: 1,
        templateStr: "Yesterday, {metric} {operator} {value}"
    },
    {
        name: "Based-on the change of metric in two periods: yesterday AND before yesterday",
        nameTranslate: "",
        value: 2,
        templateStr: "{metric} in yesterday is {operator} {value} than {metric} in before yesterday"
    },
    {
        name: "Based on the ratio between 2 metrics of yesterday",
        nameTranslate: "",
        value: 3,
        templateStr: "Yesterday, the ratio of {metric} {operator} {value}"
    }
];
export var actionCauseTypesRight = [
    {
        name: "User define",
        value: 0,
        templateStr: "",
        translateTxt: "user_define"
    },
];
export var durationCheckingOptions = [
    {
        value: "YESTERDAY",
        label: "Yesterday"
    },
    {
        value: "LAST_7_DAYS",
        label: "Last 7 Days"
    },
    {
        value: "LAST_14_DAYS",
        label: "Last 14 Days"
    },
    {
        value: "LAST_28_DAYS",
        label: "Last 28 Days"
    },
    {
        value: "CUSTOM_PERIOD",
        label: "Custom Period"
    }
];
export var durationCompareOptions = [
    {
        value: "BEFORE_YESTERDAY",
        label: "Before Yesterday"
    },
    {
        value: "LAST_7_DAYS",
        label: "Last 7 Days"
    },
    {
        value: "LAST_14_DAYS",
        label: "Last 14 Days"
    },
    {
        value: "LAST_28_DAYS",
        label: "Last 28 Days"
    },
    {
        value: "CUSTOM_PERIOD",
        label: "Custom Period"
    }
];
export var buildTemplateCauseString = function (causeData, isHtml, actionTypeList) {
    var template = "";
    if (causeData.left && causeData.left.metrics && causeData.left.metrics.length) {
        var listCauseLeft = (causeData.left.metrics || []).map(function (causeLeft) {
            return causeLeft.name;
        });
        var foundOperator = comparisonOperators.find(function (operator) {
            return causeData.comparisionOp === operator.value;
        });
        var foundLeftActionType = actionTypeList.find(function (actionCauseType) {
            return actionCauseType.value == causeData.left.actionType;
        });
        var titleLeftCause = "Left in cause form";
        var titleRightCause = "Right in cause form";
        // template += foundLeftActionType && foundLeftActionType.value == 3 ? "Yesterday, the ratio of  " : "";
        template += isHtml ? "<strong title='" + titleLeftCause + "'>" + listCauseLeft.join("/") + "</strong>" : listCauseLeft.join("/");
        if (foundLeftActionType && foundLeftActionType.templateStr) {
            template = replaceAllCharacter(foundLeftActionType.templateStr, "{metric}", template);
        }
        if (foundOperator) {
            var operatorTemplate = isHtml ? foundOperator.characterHtml : foundOperator.character;
            if (operatorTemplate) {
                template = replaceAllCharacter(template, "{operator}", operatorTemplate);
            }
        }
        if (causeData.right && causeData.right.values) {
            var listCauseRight = (causeData.right.values || []).map(function (causeRight) {
                var causeRightStr = "";
                if (causeData.left.actionType == 2 || causeData.left.actionType == 3) {
                    causeRight = Number(causeRight);
                    if (causeRight) {
                        causeRight = Math.abs(causeRight);
                    }
                    causeRightStr += "" + causeRight + "%";
                }
                else {
                    if (causeData.left.metrics && causeData.left.metrics.length) {
                        var metric = causeData.left.metrics[0];
                        if (metric.dataType == "NUMBER") {
                            causeRight = Number(causeRight);
                            if (causeRight) {
                                causeRight = Math.abs(causeRight);
                            }
                        }
                        causeRightStr += causeRight || causeRight == 0 ? formatValueByMetric(causeRight, metric.category, metric.dataType, metric.decimalPrecision) : causeRight;
                    }
                }
                causeRightStr = isHtml ? "<strong title='" + titleRightCause + "'>" + causeRightStr + "</strong>" : causeRightStr;
                return causeRightStr;
            });
            var valueRight = "";
            if (foundOperator && (foundOperator.value == "IN" || foundOperator.value == "NIN" || foundOperator.value == "IS")) {
                valueRight = "{" + listCauseRight.join(", ") + "}";
            }
            else if (foundOperator && foundOperator.value == "LIKE") {
                valueRight = '"' + listCauseRight.join(" or ") + '"';
            }
            else {
                valueRight = " " + listCauseRight.join(", ");
            }
            template = replaceAllCharacter(template, "{value}", valueRight);
        }
    }
    return template;
};
export var buildTemplateRuleSettingString = function (ruleSetting, actionTypeList, marginLeftAnd) {
    var ruleDetailString = "";
    var buildCauseGroupsTemplate = function (causeGroups, logical, marginLeftAnd) {
        var causeGroupsStr = "";
        causeGroups.forEach(function (causeGroup) {
            if (causeGroup) {
                var causeGroupStr = buildTemplateRuleSettingString(causeGroup, actionTypeList, marginLeftAnd);
                if (causeGroupStr) {
                    if (logical == "and") {
                        causeGroupsStr += causeGroupStr;
                    }
                    else {
                        causeGroupsStr += "<span style='margin-left:" + marginLeftAnd + "px;'><strong>Or</strong></span>" + causeGroupStr;
                    }
                    // causeGroupsStr += logical + " ( " + causeGroupStr + " )";
                }
            }
        });
        return causeGroupsStr;
    };
    if (ruleSetting && ruleSetting.logicalOp) {
        var foundLogical = logicalRuleSetting.find(function (logical) {
            return logical.value == ruleSetting.logicalOp;
        });
        if (foundLogical) {
            var logicalStr = foundLogical.label.toLowerCase();
            marginLeftAnd = marginLeftAnd + 5;
            if (ruleSetting.causeForms) {
                var ruleCauses = ruleSetting.causeForms.map(function (cause) {
                    return buildTemplateCauseString(cause, true, actionTypeList);
                });
                if (logicalStr == "and") {
                    ruleCauses.forEach(function (ruleCause) {
                        ruleDetailString += "<li style='margin-left:" + marginLeftAnd + "px;'>" + ruleCause + "</li>";
                    });
                    // ruleDetailString += ruleCauses.join(" " + logicalStr + " ");
                }
                else {
                    ruleCauses.forEach(function (ruleCause, index) {
                        var marginCauseStr = marginLeftAnd + 5;
                        var brStr = index == ruleCauses.length - 1 ? "" : "<span style='margin-left:" + marginLeftAnd + "px;'><strong>Or</strong></span>";
                        ruleDetailString += "<li style='margin-left:" + marginCauseStr + "px;'>" + ruleCause + "</li>" + brStr;
                    });
                    // ruleDetailString += ruleCauses.join("<br><strong>Or</strong><br>");
                }
                // ruleDetailString += ruleCauses.join(" " + logicalStr + " ");
            }
            if (ruleSetting.causeGroupForms && ruleSetting.causeGroupForms.length) {
                var ruleGroupStr = buildCauseGroupsTemplate(ruleSetting.causeGroupForms, logicalStr, marginLeftAnd);
                if (ruleGroupStr) {
                    ruleDetailString += " " + ruleGroupStr;
                }
            }
        }
    }
    return ruleDetailString;
};
export var buildDateString = function (type, resultObject) {
    var numberDate = 7;
    switch (type) {
        case "LAST_14_DAYS":
            numberDate = 14;
            break;
        case "LAST_28_DAYS":
            numberDate = 28;
            break;
        default:
            numberDate = 7;
            break;
    }
    var formatDate = "YYYY/MM/DD";
    var dateCurrent = moment().subtract(1, 'days').format(formatDate);
    var dateAfter = moment().subtract(numberDate, 'days').format(formatDate);
    if (resultObject) {
        return {
            startDate: dateAfter,
            endDate: dateCurrent
        };
    }
    return "From " + dateAfter + " To " + dateCurrent;
};
export var buildOptionsSliderByNum = function (num) {
    var formatDate = "YYYY/MM/DD";
    var dates = [];
    var maxDate = moment().subtract(1, 'days');
    var minDate = moment().subtract(num + 1, 'days');
    var diffDate = moment.duration(maxDate.diff(minDate)).asDays();
    diffDate = Math.round(diffDate);
    for (var i = 1; i <= diffDate; i++) {
        if (i == diffDate) {
            dates.push({ value: i - 1, valueOfDate: moment(minDate).add(i, 'days').valueOf(), legend: 'Yesterday' });
        }
        else {
            dates.push({ value: i - 1, valueOfDate: moment(minDate).add(i, 'days').valueOf(), legend: moment(minDate).add(i, 'days').format(formatDate) });
        }
    }
    return dates;
};
export var buildOptionsSlider = function (type) {
    var numberDate = 7;
    switch (type) {
        case "1m":
            numberDate = 1;
            break;
        case "3m":
            numberDate = 3;
            break;
        default:
            numberDate = 7;
            break;
    }
    var formatDate = "YYYY/MM/DD";
    var dates = [];
    var maxDate = moment().subtract(1, 'days');
    var minDate = moment().subtract(8, 'days');
    if (type == "1m" || type == "3m") {
        minDate = moment().subtract(numberDate, 'month').subtract(1, 'days');
    }
    var diffDate = moment.duration(maxDate.diff(minDate)).asDays();
    diffDate = Math.round(diffDate);
    for (var i = 1; i <= diffDate; i++) {
        if (i == diffDate) {
            dates.push({ value: i - 1, valueOfDate: moment(minDate).add(i, 'days').valueOf(), legend: 'Yesterday' });
        }
        else {
            dates.push({ value: i - 1, valueOfDate: moment(minDate).add(i, 'days').valueOf(), legend: moment(minDate).add(i, 'days').format(formatDate) });
        }
    }
    return dates;
};
export var buildFormDataAlert = function (data) {
    var form = {
        name: data.name,
        description: data.description || "",
        standardAlertSettingId: data.ruleSetting && data.ruleSetting.standardAlertSettingId > -1 ? data.ruleSetting.standardAlertSettingId : -1,
        scheduleSettings: data.settings.scheduleSettings,
        enabled: data.enabled,
        objectType: data.settings && data.settings.reportDataSetting && data.settings.reportDataSetting.levelData ? data.settings.reportDataSetting.levelData : "",
        recipientSetting: data.settings.recipientSetting,
        sendingSettings: data.settings.sendingSettings,
        parentFilters: data.settings && data.settings.reportDataSetting && data.settings.reportDataSetting.parentFilters ? JSON.parse(data.settings.reportDataSetting.parentFilters) : "",
        ruleSetting: data.ruleSetting
    };
    var dynamicDuration = data.settings && data.settings.reportDataSetting && data.settings.reportDataSetting.datasourceCompare ? data.settings.reportDataSetting.datasourceCompare : {
        "customDurationTypeRange": "BEFORE_YESTERDAY",
    };
    var dynamicDurationChecking = data.settings && data.settings.reportDataSetting && data.settings.reportDataSetting.datasourceChecking ? data.settings.reportDataSetting.datasourceChecking : {
        "customDurationTypeRange": "YESTERDAY",
    };
    if (dynamicDuration) {
        form.customDurationTypeRange = dynamicDuration.customDurationTypeRange ? dynamicDuration.customDurationTypeRange : "BEFORE_YESTERDAY";
        form.customDurationSlideLength = dynamicDuration.customDurationSlideLength ? dynamicDuration.customDurationSlideLength : "7d";
        form.customDurationNumOfDays = dynamicDuration.customDurationNumOfDays ? dynamicDuration.customDurationNumOfDays : "";
        form.customDurationDistanceToEnd = dynamicDuration.customDurationDistanceToEnd ? dynamicDuration.customDurationDistanceToEnd : "";
        if (dynamicDuration.customDurationTypeRange == "CUSTOM_PERIOD") {
            form.customDurationFromDate = dynamicDuration.customDurationFromDate ? dynamicDuration.customDurationFromDate : "";
            form.customDurationToDate = dynamicDuration.customDurationToDate ? dynamicDuration.customDurationToDate : "";
        }
    }
    if (dynamicDurationChecking) {
        form.checkingDurationTypeRange = dynamicDurationChecking.customDurationTypeRange ? dynamicDurationChecking.customDurationTypeRange : "YESTERDAY";
        form.checkingDurationSlideLength = dynamicDurationChecking.customDurationSlideLength ? dynamicDurationChecking.customDurationSlideLength : "7d";
        form.checkingDurationNumOfDays = dynamicDurationChecking.customDurationNumOfDays ? dynamicDurationChecking.customDurationNumOfDays : "";
        form.checkingDurationDistanceToEnd = dynamicDurationChecking.customDurationDistanceToEnd ? dynamicDurationChecking.customDurationDistanceToEnd : "";
        if (dynamicDurationChecking.customDurationTypeRange == "CUSTOM_PERIOD") {
            form.checkingDurationFromDate = dynamicDurationChecking.customDurationFromDate ? dynamicDurationChecking.customDurationFromDate : "";
            form.checkingDurationToDate = dynamicDurationChecking.customDurationToDate ? dynamicDurationChecking.customDurationToDate : "";
        }
    }
    return form;
};
export var buildTemplateCauseAlertCardString = function (causeData) {
    var template = "";
    if (causeData.left && causeData.left.metrics && causeData.left.metrics.length) {
        var listCauseLeft = (causeData.left.metrics || []).map(function (causeLeft) {
            return causeLeft.name;
        });
        var foundOperator = comparisonOperators.find(function (operator) {
            return causeData.comparisionOp === operator.value;
        });
        var foundLeftActionType = actionCauseTypes.find(function (actionCauseType) {
            return actionCauseType.value == causeData.left.actionType;
        });
        template += listCauseLeft.join("/");
        if (foundLeftActionType && foundLeftActionType.templateStr) {
            template = foundLeftActionType.templateStr.replace("{metric}", template);
        }
        if (foundOperator) {
            template += " " + foundOperator.character;
        }
        if (causeData.right && causeData.right.values) {
            var listCauseRight = (causeData.right.values || []).map(function (causeRight) {
                return causeRight;
            });
            template += " " + listCauseRight.join(", ");
        }
    }
    return template;
};
export var buildTemplateRuleSettingAlertCardString = function (ruleSetting) {
    var ruleDetailString = "";
    var buildCauseGroupsTemplateAlertCard = function (causeGroups, logical) {
        var causeGroupsStr = "";
        causeGroups.forEach(function (causeGroup) {
            if (causeGroup) {
                var causeGroupStr = buildTemplateRuleSettingAlertCardString(causeGroup);
                if (causeGroupStr) {
                    causeGroupsStr += logical + " ( " + causeGroupStr + " )";
                }
            }
        });
        return causeGroupsStr;
    };
    if (ruleSetting && ruleSetting.logicalOp) {
        var foundLogical = logicalRuleSetting.find(function (logical) {
            return logical.value == ruleSetting.logicalOp;
        });
        if (foundLogical) {
            var logicalStr = foundLogical.label.toLowerCase();
            if (ruleSetting.causeForms) {
                var ruleCauses = ruleSetting.causeForms.map(function (cause) {
                    return buildTemplateCauseAlertCardString(cause);
                });
                ruleDetailString += ruleCauses.join(" " + logicalStr + " ");
            }
            if (ruleSetting.causeGroupForms && ruleSetting.causeGroupForms.length) {
                var ruleGroupStr = buildCauseGroupsTemplateAlertCard(ruleSetting.causeGroupForms, logicalStr);
                if (ruleGroupStr) {
                    ruleDetailString += " " + ruleGroupStr;
                }
            }
        }
    }
    return ruleDetailString;
};
